export type SpeakerType = 'user' | 'agent' | 'ai' | 'unknown';

// Check if string is a UUID format (e.g., xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx)
export const isUUID = (str: string): boolean => {
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return uuidRegex.test(str);
};

// Determine speaker type based on participant identity pattern
export const getSpeakerType = (participantIdentity: string): SpeakerType => {
    if (!participantIdentity) {
        return 'unknown';
    }

    // AI assistant: starts with "agent-"
    if (participantIdentity.startsWith('agent-') || participantIdentity.startsWith('assistant')) {
        return 'ai';
    }

    // Human agent: UUID format
    if (isUUID(participantIdentity)) {
        return 'agent';
    }

    // Customer/User: phone number format (starts with "+")
    if (participantIdentity.startsWith('+1') || participantIdentity.startsWith('user')) {
        return 'user';
    }

    // Default fallback
    return 'unknown';
};

export const getSpeakerLabel = (speakerType: SpeakerType): string => {
    switch (speakerType) {
        case 'user':
            return 'Customer';
        case 'agent':
            return 'Agent';
        case 'ai':
            return 'AI';
        default:
            return 'Unknown';
    }
};
